import { Box, lighten, styled } from '@mui/material';
import Text from '@components/Text/Text';
import { ColorTypes } from '@customTypes/colors';

export const StyledBannerContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'colorType',
})<{ colorType: ColorTypes }>(({ theme, colorType }) => ({
  border: `1px solid ${theme.palette?.[colorType].main}`,
  backgroundColor: lighten(theme.palette?.[colorType].main, 0.9),
  padding: theme.spacing(6, 8),
  flexDirection: 'row',
  display: 'inline-flex',
  borderRadius: theme.spacing(4),
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(5, 7),
  },
}));

export const BannerLabelText = styled(Text, {
  shouldForwardProp: (prop) => prop !== 'isIcon' && prop !== 'colorType',
})<{
  isIcon: boolean;
  colorType: ColorTypes;
}>(({ theme, colorType, isIcon }) => ({
  color: theme.palette?.[colorType].main ?? theme.palette.common.black,
  marginLeft: isIcon ? theme.spacing(7) : 0,
  lineHeight: theme.spacing(10),
  [theme.breakpoints.down('md')]: {
    marginLeft: isIcon ? theme.spacing(5) : 0,
  },
  textAlign: 'start',
}));
